<template>
  <div class="baseSlider">
    <SplashScreen v-if="!banners.length" />
    <div v-if="banners" class="slider_wrapper swiper-container">
      <div class="swiper-wrapper">
        <div
          :id="index"
          class="swiper-slide"
          v-for="(banner,index) in banners"
          :key="index"
          @click="getMerchandiseProducts(banner.id)"
        >
        <img :src="banner.bannerUrl" :alt="banner.title" />
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import ImageSpinner from "../Common/ImageSpinner";
import SplashScreen from "../Common/SplashScreen";
import { mapState } from "vuex";
import constant from "../../utils/constant";
import Swiper from "swiper";
import "../../assets/css/swiper-slider.css";
export default {
  name: "BaseSlider",
  components: {
    ImageSpinner,
    SplashScreen
  },
  data() {
    return {
      banners: [],
      loading: false
    };
  },
  methods: {
    getMerchandiseProducts(merchandiseId) {
      clevertap.event.push("merchandising_banner_click", {
        merchandiseId: merchandiseId
      });
      if (merchandiseId == 359) {
        this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
        this.$router.push("/diwali-gift/" + merchandiseId);
      } else {
        this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
        this.$router.push("/merchandise-product-by-id/" + merchandiseId);
      }
    },
    getMerchandiseHome() {
      this.loading = true;
      this.$store
        .dispatch({
          type: "getMerchandiseHome",
          payload: true
        })
        .then(data => {
          this.loading = false;
          if (data.data.merchandiseBannerDTOs.length > 0) {
            this.banners = data.data.merchandiseBannerDTOs;
            this.$nextTick(() => {
              var swiper = new Swiper(".swiper-container", {
                loop: true,
                spaceBetween: 10,
                centeredSlides: true,
                autoplay: {
                delay: 4000,
                disableOnInteraction: false
              },
                pagination: {
                  el: ".swiper-pagination",
                  clickable: true
                }
              });
            });
            this.$store.commit("saveBanners", {
              banners: this.banners,
              bannerId: 0
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    if (this.$store.getters.banners && this.$store.getters.banners.length > 0) {
      this.banners = this.$store.getters.banners;
      this.$nextTick(() => {
        var swiper = new Swiper(".swiper-container", {
          loop: true,
          spaceBetween: 10,
          centeredSlides: true,
          autoplay: {
                delay: 4000,
                disableOnInteraction: false
              },
          pagination: {
            el: ".swiper-pagination",
            clickable: true
          }
        });
      });
    } else {
      this.getMerchandiseHome();
    }
  }
};
</script>
<style scoped>
.swiper-container {
  width: 100%;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.swiper-slide img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  /* background: antiquewhite; */

  border-radius: 15px;
}
</style>
